import MailBoxContent from "./MailBoxContent";
export default MailBoxContent;
